import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL + '/api/portal';

const auth = () => ({
  headers: { Authorization: `Bearer ${sessionStorage.getItem('portalToken')}` },
});

const login = (badgeNumber, password, companyId) =>
  axios.post(`${BASE}/login`, { badgeNumber, password, companyId }).then(r => r.data);

const changePassword = (currentPassword, newPassword) =>
  axios.post(`${BASE}/change-password`, { currentPassword, newPassword }, auth()).then(r => r.data);

const getMe = () =>
  axios.get(`${BASE}/me`, auth()).then(r => r.data.employee);

const updateMe = (data) =>
  axios.put(`${BASE}/me`, data, auth()).then(r => r.data);

const getHours = (from, to) =>
  axios.get(`${BASE}/hours`, { ...auth(), params: { from, to } }).then(r => r.data);

const getPay = (from, to) =>
  axios.get(`${BASE}/pay`, { ...auth(), params: { from, to } }).then(r => r.data);

const getPto = (year) =>
  axios.get(`${BASE}/pto`, { ...auth(), params: { year } }).then(r => r.data);

const submitPtoRequest = (data) =>
  axios.post(`${BASE}/pto/request`, data, auth()).then(r => r.data.request);

const cancelPtoRequest = (id) =>
  axios.delete(`${BASE}/pto/request/${id}`, auth()).then(r => r.data);

const getPoints = (year) =>
  axios.get(`${BASE}/points`, { ...auth(), params: { year } }).then(r => r.data);

const getTrainingAssignments = () =>
  axios.get(`${BASE}/training`, auth()).then(r => r.data.assignments);

const getTrainingAssignment = (id) =>
  axios.get(`${BASE}/training/${id}`, auth()).then(r => r.data);

const markTrainingMaterialViewed = (id) =>
  axios.post(`${BASE}/training/${id}/material-viewed`, {}, auth()).then(r => r.data);

const startTraining = (id) =>
  axios.post(`${BASE}/training/${id}/start`, {}, auth()).then(r => r.data);

const submitTraining = (id, responses, startedAt) =>
  axios.post(`${BASE}/training/${id}/submit`, { responses, startedAt }, auth()).then(r => r.data);

const portalService = {
  login, changePassword,
  getMe, updateMe,
  getHours, getPay,
  getPto, submitPtoRequest, cancelPtoRequest,
  getPoints,
  getTrainingAssignments, getTrainingAssignment, markTrainingMaterialViewed, startTraining, submitTraining,
};

export default portalService;
